module.exports = __webpack_public_path__ + "static/media/AA11242-Audi-driving-experience-voucher-no-price.f6be41c3.jpg";